import React, { useState } from "react";

import { CSVLink } from "react-csv";

import { useUmpiresContext } from "../../../contexts/Umpires";
import { CSVData } from "../types/umpires";

import { IUmpireUser } from "../../../../../../types/api";
import { capitalize } from "lodash";

const DownloadButton = (): React.JSX.Element => {
    const { umpires, type } = useUmpiresContext();

    const [csvData, setCSVData] = useState<Array<CSVData>>([]);
    const CSVHeaders = [
        { label: "First Name", key: "firstName" },
        { label: "Last Name", key: "lastName" },
        { label: "Email", key: "email" },
        { label: "City", key: "city" },
        { label: "State", key: "state" },
        { label: "Phone", key: "phone" },
        { label: "Date of Birth", key: "dob" },
        { label: "SSN", key: "ssn" },
        { label: "Race", key: "race" },
        { label: "Gender", key: "gender" },
        { label: "Games", key: "games" },
        { label: "Ratings", key: "ratings" },
    ];

    const generateCSVRow = (u: IUmpireUser): CSVData => {
        return {
            firstName: u.meta.firstName,
            lastName: u.meta.lastName,
            email: u.email,
            city: u.meta.city,
            state: u.meta.state,
            phone: u.meta.phoneNumbers.primary,
            dob: u.meta.dob,
            ssn: u.meta.ssn,
            race: u.meta.race,
            gender: u.meta.gender,
            games: u.games,
            ratings: u.ratings,
        };
    };

    const handleDownload = () => {
        const CSVData = umpires.map(u => generateCSVRow(u));
        setCSVData(CSVData);
    };

    return (
        <CSVLink
            data={csvData}
            headers={CSVHeaders}
            filename={`${capitalize(type)}Umpires.${new Date().getTime()}.csv`}
            className="btn btn-primary"
            target="_blank"
            onClick={handleDownload}
        >
            Download Excel File
        </CSVLink>
    );
};

export default DownloadButton;
